export class Level {

  // constructor() {
  // }

  buildModel() {}

  /*
   * Get a attribute by name.
   * Accepts dimension level in the input string.
   */
  getAttribute(attribute) {

    const attr = $.grep(this.attributes, function(el) {
      return el.name == attribute;
    })[0];

    return attr;
  }

  /*
   * Processes a cell and returns an object with a stable information:
   * o.key
   * o.label
   * o.info[]
   */
  readCell(cell) {
    const key = this.getAttribute(this.key).ref;
    if (!cell || !(key in cell)) return null;

    const result = {};
    result.key = cell[key];
    const labelKey = this.getAttribute(this.label_attribute).ref;
    const labelKeyDisplay = `${labelKey}_display_label`;
    result.label = (labelKeyDisplay in cell) ? cell[labelKeyDisplay] : cell[labelKey];
    result.info = {};
    this.attributes.forEach((attribute) => {
      result.info[attribute.name] = cell[attribute.ref];
    });
    return result;
  }

  toString() {
    return this.dimension.toString().split(':')[0] + ':' + this.name;
  }

}



// WEBPACK FOOTER //
// ./src/common/level.js